import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { PasswordConfirm } from '@app/shared/components/form/validators';
import { ToastService } from '@teorema/patron';
import { CoreConfig } from 'src/app/models/core-config.model';
import { constants } from 'src/app/shared';
import { AuthService } from '../../auth.service';
import { FirebaseService } from '../../firebase.service';
import { FirebaseErrors } from '../firebase-errors';

@Component({
  templateUrl: './new-password.component.html',
  standalone: false,
})
export class NewPasswordComponent implements OnInit, OnDestroy {
  config: CoreConfig;

  constructor(
    private fb: FormBuilder,
    private authService: AuthService,
    private firebaseService: FirebaseService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private toastService: ToastService,
    private titleService: Title
  ) {
    this.formGroup = this.fb.group(
      {
        email: ['', [Validators.required, Validators.email]],
        password: ['', [Validators.required, Validators.minLength(6)]],
        confirm: ['', Validators.required],
      },
      {
        validators: [PasswordConfirm('password', 'confirm')],
      }
    );

    this.config = this.authService.getCoreConfig();
  }

  ngOnInit(): void {
    setTimeout(() => {
      this.titleService.setTitle(`Nova senha | ${this.config.panelTitle}`);
    }, 100);

    const email = localStorage.getItem(constants.patronChangePasswordEmail);
    this.formGroup.patchValue({ email });

    this.activatedRoute.queryParams.subscribe(params => {
      if (params['oobCode']) {
        this.code = params['oobCode'];
      } else {
        this.router.navigate(['']);
      }
    });
  }

  ngOnDestroy(): void {
    this.titleService.setTitle(this.config.panelTitle!);
  }

  formGroup!: FormGroup;
  loading: boolean = false;
  submitted: boolean = false;
  code: string = '';

  get f() {
    return this.formGroup.controls;
  }

  async onSubmit() {
    this.submitted = true;

    if (this.formGroup.invalid) {
      return;
    }

    this.loading = true;

    const { email, password } = this.formGroup.value;
    let apiGeralToken: string | undefined = undefined;

    await this.firebaseService
      .confirmPasswordReset(this.code, password)
      .then(async () => {
        await this.firebaseService
          .firebaseLogin(email, password)
          .then(async response => {
            if (response) {
              const user = response.user;
              const firebaseToken = await user?.getIdToken();
              const apiGeralResponse = await this.authService.apiGeralLogin(
                email,
                password,
                firebaseToken,
                null,
                null,
                this.config.firebaseProjectId
              );
              apiGeralToken = apiGeralResponse?.access_token;
            }
          })
          .catch(err => {
            throw err;
          });

        if (apiGeralToken) {
          localStorage.removeItem(constants.patronChangePasswordEmail);
          this.toastService.show({
            message: 'A senha foi alterada, acesse o sistema com a sua nova senha',
            color: 'success',
          });

          this.router.navigate(['/auth']);
        } else {
          this.toastService.show({ color: 'error', message: 'Houve um erro ao alterar a senha' });
        }
      })
      .catch(error => {
        console.error(error);

        this.toastService.show({
          message: FirebaseErrors.Parse(error?.code),
          color: 'error',
        });
      });

    this.loading = false;
  }
}
